import { useNavigate } from 'react-router-dom';
import styles from './Auth.module.css';
import SubmitButton from './SubmitButton';
import { useState, useContext } from 'react';
import { roles } from './roles';
import { Context } from '../../AuthContext';
import Spinner from '../../components/Spinner';

const SelectRolePage = () => {
  const navigate = useNavigate();
  const { user, authLoading } = useContext(Context);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const formData = new FormData(e.target);
    const selectedRole = formData.get('role');

    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'edit_user';
    const token = await user.getIdToken();
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ role: selectedRole }),
    });

    if (selectedRole === 'Researcher' || selectedRole === 'University Administration') {
      setSubmitting(false);
      navigate('/select-sub-role', {
        state: {
          role: selectedRole,
        },
      });
    } else if (selectedRole === 'Other') {
      setSubmitting(false);
      navigate('/describe-role');
    } else {
      //navigate('/tryrnai');
      navigate('/select-plan');
    }
  };

  return !authLoading ? (
    <div>
      <h2>Select your primary role</h2>
      <p style={{ fontWeight: '500', fontSize: '20px' }}>
        to ensure your best experience using The Simple Platform
      </p>
      <form
        onSubmit={onSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
          margin: '0 auto',
        }}
      >
        <p style={{ fontWeight: '700', fontSize: '16px', position: 'relative', left: '30px' }}>
          My role better described as:
        </p>
        {Object.entries(roles).map(([role, description], index) => (
          <div className={styles.role}>
            <input
              key={index}
              type="radio"
              id={role}
              name="role"
              value={role}
              defaultChecked={index === 0}
            ></input>
            <div>
              <label for={role}>
                {role}
                <p className={styles.roleDescription}>{description}</p>
              </label>
            </div>
          </div>
        ))}
        <div className={styles.footer}>
          <SubmitButton text="Continue" width="25%" height="48px" disabled={submitting} />
        </div>
      </form>
    </div>
  ) : (
    <Spinner />
  );
};
export default SelectRolePage;
